import { handleMensurationWaterTreatment } from "./handleMensurationWaterTreatment";
import { handleMensurationMeasurementSectorization } from "./handleMensurationMeasurementSectorization";
import { handleMensurationEffluentTreatment } from "./handleMensurationEffluentTreatment";
import { handleMensurationFinalProduct } from "./handleMensurationFinalProduct";
import { handleMensurationInput } from "./handleMensurationInput";
import { handleMensurationOthers } from "./handleMensurationOthers";

import { handleMenagementBusinessPlanning } 					from "./handleMenagementBusinessPlanning";
import { handleMenagementGovernanceResponsibilities } from "./handleMenagementGovernanceResponsibilities";

import { handleComunicationComunication } from "./handleComunicationComunication";
import { handleComunicationEngagement } 	from "./handleComunicationEngagement";

export const functions = {
	handle_mensuration_waterTreatment						: handleMensurationWaterTreatment,
	handle_mensuration_measurementSectorization	: handleMensurationMeasurementSectorization,
	handle_mensuration_effluentTreatment				: handleMensurationEffluentTreatment,
	handle_mensuration_finalProduct							: handleMensurationFinalProduct,
	handle_mensuration_input										: handleMensurationInput,
	handle_mensuration_others										: handleMensurationOthers,
	
	handle_menagement_businessPlanning						: handleMenagementBusinessPlanning,
	handle_menagement_governanceResponsibilities	: handleMenagementGovernanceResponsibilities,
	
	handle_comunication_comunications	: handleComunicationComunication,
	handle_comunication_engagement		: handleComunicationEngagement,

	
};


// WEBPACK FOOTER //
// src/helpers/subcategoriesFunctions/index.js